import { useContext } from "react";
import { AdvancedFiltersContext } from "contexts/advanced-filters/advanced-filters-provider";

export const useAdvancedFiltersForm = () => useContext(AdvancedFiltersContext);
